// routes/admin.routes.tsx
import { lazy } from 'react';
// import AdminProtected from './AdminProtected';
// import DashboardLayout from '../components/Layouts/DashboardLayout';

const AdminProtected = lazy(() => import('./AdminProtected'));
const AdminManageBoost = lazy(
  () => import('../components/dashboard/adminDashboard/AdminManageBoosts')
);
const DashboardLayout = lazy(() => import('../components/Layouts/DashboardLayout'));
const AdminDashboardHomePage = lazy(
  () => import('../components/dashboard/adminDashboard/AdminHomepageDashboard')
);
const AdminManageListings = lazy(
  () => import('../components/dashboard/adminDashboard/AdminManageListings')
);
const AdminEditListing = lazy(
  () => import('../components/dashboard/adminDashboard/AdminEditListing')
);
const AdminManageUsers = lazy(
  () => import('../components/dashboard/adminDashboard/AdminManageUsers')
);
const AdminManagePosts = lazy(
  () => import('../components/dashboard/adminDashboard/AdminManagePosts')
);
const AdminHuntingboard = lazy(
  () => import('../components/dashboard/adminDashboard/AdminHuntingboard')
);
const AdminHunts = lazy(() => import('../components/dashboard/adminDashboard/AdminHunts'));
const AdminEditHunt = lazy(() => import('../components/dashboard/adminDashboard/AdminEditHunt'));
const AdminManageBusinesses = lazy(
  () => import('../components/dashboard/adminDashboard/AdminManageBusinesses')
);
const AdminMatches = lazy(() => import('../components/dashboard/adminDashboard/AdminMatches'));
const AdminPromotedCardsPage = lazy(() => import('../pages/AdminPromotedCardsPage'));
const AdminInteractions = lazy(
  () => import('../components/dashboard/adminDashboard/AdminInteractions')
);
const AdminAnalytics = lazy(() => import('../pages/AdminAnalytics'));
const AvailabilityRequestList = lazy(
  () => import('../components/dashboard/adminDashboard/AvailabilityRequestList')
);

export const adminRoutes = [
  {
    path: '/admin',
    element: (
      <AdminProtected>
        <DashboardLayout />
      </AdminProtected>
    ),
    children: [
      {
        path: 'dashboard',
        element: <AdminDashboardHomePage />,
      },
      {
        path: 'listings',
        element: <AdminManageListings />,
      },
      {
        path: 'edit-listing/:id',
        element: <AdminEditListing />,
      },
      {
        path: 'users',
        element: <AdminManageUsers />,
      },
      {
        path: 'square',
        element: <AdminManagePosts />,
      },
      {
        path: 'huntingboard',
        element: <AdminHuntingboard />,
      },
      {
        path: 'hunts',
        element: <AdminHunts />,
      },
      {
        path: 'edit-hunt/:id',
        element: <AdminEditHunt />,
      },
      {
        path: 'businesses',
        element: <AdminManageBusinesses />,
      },
      {
        path: 'matches',
        element: <AdminMatches />,
      },
      {
        path: 'promoted-cards',
        element: <AdminPromotedCardsPage />,
      },
      {
        path: 'interactions',
        element: <AdminInteractions />,
      },
      {
        path: 'analytics',
        element: <AdminAnalytics />,
      },
      {
        path: 'boosts',
        element: <AdminManageBoost />,
      },
      {
        path: 'requests',
        element: <AvailabilityRequestList />,
      },
    ],
  },
];
